const NS = 'PublicationListingPage';
const CLS = 'publicationListingPage';

import * as Api from '../../../../global/js/api';
import Handlebars from 'handlebars';
import { initPagination } from '../../../../global/js/pagination';

import { BookmarkSquareWidget } from '../../../widgets/bookmarkSquareWidget/js/bookmarkSquareWidget';
import { PublicationListingItemWidget } from '../../../widgets/publicationListingItemWidget/js/publicationListingItemWidget';

export class PublicationListingPage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.pageSize = this.$element.data('pageSize');
		this.sourceId = this.$element.data('sourceId');
		this.getApi = this.$element.data('publication-api');
		this.params = {
			sourceId: this.sourceId,
			pageNumber: 1,
			pageSize: this.pageSize
		};

		this.loadingSpinner = $('.loading-spinner');
		this.$itemsList = this.$element.find(`.tpl-content-list`);
		this.$pagination = this.$element.find(`.tpl-content-pagination`);
		this.setItemTemplate();
		this.getItems();
		this.$selects = this.$element.find(`.${CLS}-select`);
		this.$selects.on('change', (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');
			if(!(_.isNil(this.params[filterKey]) && $element.val() === '')) {
				// Ensure that the filterKey does not match the current select value
				if(this.params[filterKey] !== $element.val()) {
					if(_.isNil($element.val()) || $element.val() === '') {
						delete this.params[filterKey];
					}
					else {
						this.params[filterKey] = $element.val();
					}

					this.params.pageNumber = 1;
					this.getItems(true);
				}
			}
		});
		this.$inputSearch = this.$element.find(`.${CLS}-search-input`);
		this.$inputSearch.on('input', _.debounce((event) => {
			this.params['keyword'] = $(event.currentTarget).val().trim();

			this.params.pageNumber = 1;
			this.getItems(true);
		}, 250));
		this.$btnClearFilters = this.$element.find(`.${CLS}-btn--clearFilters`);
		this.$btnClearFilters.on('click', () => {
			// Clear select values
			this.$selects.each((index, element) => {
				let $element = $(element);
				let filterKey = $element.data('filter-key');

				delete this.params[filterKey];
				$element.val('').change();
			});
			// Clear input values
			delete this.params['keyword'];
			this.$inputSearch.val('');

			this.params.pageNumber = 1;
			this.getItems(true);
		});
		this.$element.on('pagination.trigger', () => {
			this.getItems(true);
		});
	}

	getItems(paging = false) {
		let url = this.getApi;

		if(!_.isEmpty(this.params)) {
			url += `?${$.param(this.params)}`;
		}

		this.$itemsList.empty();
		this.loadingSpinner.addClass('is-active');

		Api.getApi(url).then((data) => {
			let items = data.results;
			if(items.length > 0) {
				items.forEach((item) => {
					item.bookmarkSquareWidget = this.bookmarkSquareWidget;
					item.bookmarkSquareWidget.id = item['bookmarkId'];
					item.bookmarkSquareWidget.isMarked = item['isBookmarked'];
					let itemMarkup = this.itemTemplate(item);
					this.$itemsList.append(itemMarkup);
					new BookmarkSquareWidget(this.$element.find('.bookmarkSquareWidget').last()[0]);
					new PublicationListingItemWidget(this.$element.find('.publicationListingItemWidget').last()[0]);
				});
				initPagination(this.pageSize, data.totalCount, this.$pagination, this);
			}
			else {
				this.$itemsList.html(this.getEmptyResultTemplate());
			}

			this.loadingSpinner.removeClass('is-active');
		}, () => {
			this.loadingSpinner.removeClass('is-active');
		});
	}

	setItemTemplate() {
		let publicationItemPartial = require('../../../widgets/publicationListingItemWidget/tmpl/publicationListingItemWidget.hbs');
		let bookMarkSquarePartial = require('../../../widgets/bookmarkSquareWidget/tmpl/bookmarkSquareWidget.hbs');
		Handlebars.registerPartial('publicationListingItemWidget', publicationItemPartial);
		Handlebars.registerPartial('bookmarkSquareWidget', bookMarkSquarePartial);

		this.bookmarkSquareWidget = {
			wg: 'bookmarkSquareWidget',
			ns: 'BookmarkSquareWidget',
			bookmarkApi: this.$element.data('bookmarkApi'),
			unbookmarkApi: this.$element.data('unbookmarkApi'),
			bookmarkMessage: 'Item Saved!'
		};

		let template = `
		{{> publicationListingItemWidget
			wg="publicationListingItemWidget"
			ns="PublicationListingItemWidget"
		}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.itemTemplate = Handlebars.template(precompiled);
	}

	getEmptyResultTemplate() {
		return `<p class="${CLS}-emptyResult">Sorry, no Publication are available at the moment. Please check again later.</p>`;
	}
}
